import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const TestUnsubscribe = () => {
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="test-unsubscribe">
                <div className="box">
                    <p className="top-icon"><i class='bx bx-error-circle'></i></p>
                    <p>This is a dummy page to see the unsubscribe links. This is just for the test message that has been sent to preview the message.            </p>
                </div>
            </div>
        </div>
        <Footer/>
        </>);
}

export default TestUnsubscribe;